exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_cus[data-v-65efe944]{padding-left:1px!important;padding-right:1px!important;border-radius:0!important}.dragable[data-v-65efe944]{cursor:pointer}.dragable[data-v-65efe944]:focus{cursor:grabbing;cursor:-webkit-grabbing}", ""]);

// exports
